import { useMemo, type ReactNode } from 'react';
import { ChessRepsApi, type ApiConfig } from './client';
import { ApiContext } from './api-context';

export interface ApiProviderProps {
  config: ApiConfig;
  children: ReactNode;
}

export function ApiProvider({ config, children }: ApiProviderProps): JSX.Element {
  const { baseUrl, workspaceId, fetch, getAccessToken, onUnauthorized, onRefresh } = config;
  const api = useMemo(
    () =>
      new ChessRepsApi({ baseUrl, workspaceId, fetch, getAccessToken, onUnauthorized, onRefresh }),
    [baseUrl, workspaceId, fetch, getAccessToken, onUnauthorized, onRefresh],
  );
  return <ApiContext.Provider value={api}>{children}</ApiContext.Provider>;
}
